var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21927_203701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3387 1.64117H14.841L8.09092 21.6527C8.05641 21.7549 8.00618 21.8511 7.94204 21.9378C7.87803 22.0246 7.80085 22.1007 7.71322 22.1636C7.62559 22.2265 7.5289 22.2754 7.42616 22.3084C7.32343 22.3413 7.21629 22.3584 7.10861 22.3584H2.04819C1.88392 22.3584 1.72185 22.3194 1.57571 22.2441C1.42942 22.1691 1.30314 22.0602 1.20735 21.9266C1.1115 21.7929 1.04879 21.6384 1.0244 21.4758C0.999954 21.3132 1.01479 21.147 1.06725 20.9912L7.35611 2.34632C7.39045 2.24413 7.44072 2.14799 7.505 2.06118C7.569 1.97438 7.64647 1.89829 7.73382 1.83538C7.82145 1.77248 7.91814 1.72358 8.02088 1.69062C8.12361 1.65766 8.23074 1.64062 8.33842 1.64062V1.6409L8.3387 1.64117Z",
    fill: "url(#paint0_linear_21927_203701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3254 22.359H14.4867C14.4216 22.359 14.3565 22.3529 14.2923 22.3406C14.2282 22.3285 14.1653 22.3103 14.1046 22.2865C14.0439 22.2626 13.9857 22.2329 13.9305 22.1983C13.8753 22.1634 13.8236 22.1235 13.7758 22.0791L7.15019 15.8913C7.08011 15.8258 7.03131 15.7409 7.0101 15.6474C6.98891 15.5538 6.99636 15.4561 7.03149 15.3669C7.06662 15.2777 7.12779 15.2011 7.20705 15.1471C7.28644 15.0933 7.38011 15.0645 7.47598 15.0645H17.7869L20.3248 22.3592L20.3254 22.359Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8643 1.64259L10.3126 15.0666L17.7497 15.065L20.3008 22.3598H14.4842C14.424 22.3592 14.3638 22.3537 14.3045 22.343C14.2452 22.3323 14.1869 22.3167 14.1304 22.2958C14.0169 22.2544 13.9113 22.194 13.8183 22.117L9.34572 17.9427L8.09366 21.6351C8.06125 21.7274 8.01675 21.8151 7.96126 21.8956C7.85005 22.0575 7.69792 22.187 7.52037 22.2711C7.43198 22.3129 7.3384 22.3427 7.24211 22.3598H2.0512C1.88529 22.3603 1.72157 22.3208 1.57406 22.2444C1.42652 22.1681 1.29953 22.0574 1.20381 21.9217C1.10809 21.7859 1.04645 21.6291 1.02412 21.4646C1.00186 21.2999 1.01948 21.1323 1.07549 20.9759L7.35418 2.36174C7.38687 2.25763 7.43604 2.15957 7.49977 2.07111C7.56323 1.98266 7.64069 1.90465 7.72859 1.84037C7.8165 1.77609 7.91429 1.7261 8.01785 1.69259C8.12141 1.65907 8.22991 1.64204 8.33897 1.64259H14.8646H14.8643Z",
    fill: "url(#paint1_linear_21927_203701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9327 20.9926C22.9852 21.1485 23 21.3145 22.9758 21.4772C22.9514 21.6398 22.8888 21.7942 22.7932 21.928C22.6974 22.0615 22.5711 22.1703 22.4249 22.2454C22.2787 22.3205 22.1167 22.3597 21.9523 22.3598H14.7053C14.8696 22.3598 15.0317 22.3205 15.1781 22.2455C15.3242 22.1705 15.4506 22.0615 15.5464 21.928C15.6423 21.7945 15.7049 21.6398 15.7294 21.4772C15.7538 21.3146 15.739 21.1484 15.6865 20.9926L9.39741 2.34717C9.32818 2.14178 9.19627 1.96327 9.02025 1.83679C8.9329 1.77388 8.83621 1.72526 8.73375 1.6923C8.63128 1.65933 8.52415 1.64258 8.41675 1.64258H15.6635C15.7711 1.64258 15.878 1.65933 15.9807 1.6923C16.0832 1.72526 16.1799 1.77416 16.2675 1.83679C16.3549 1.89969 16.4321 1.97578 16.4961 2.06231C16.5601 2.14884 16.6101 2.24498 16.6447 2.34717L22.9338 20.9926H22.9327Z",
    fill: "url(#paint2_linear_21927_203701)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21927_203701",
    x1: 10.7118,
    y1: 3.17672,
    x2: 3.9543,
    y2: 23.1388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21927_203701",
    x1: 12.8187,
    y1: 12.4793,
    x2: 11.2557,
    y2: 13.0095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21927_203701",
    x1: 11.9562,
    y1: 2.59577,
    x2: 19.3729,
    y2: 22.3546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21927_203701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20.7592,
    fill: "white",
    transform: "translate(1 1.62109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/Azure.ceda9961a99f1e412dd3600db0323700.svg";
export { ForwardRef as ReactComponent };